import React, { useState } from "react";

type VariantType = "default" | "icononly";
type SizeType = "lg" | "sm";

interface CustomIconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: SizeType,
  variant?: VariantType,
  disabled?: boolean,
  customStyle?: string,
}

const CustomIconButton = ({
  size = "lg",
  variant = "default", //default | icononly
  disabled = false,
  customStyle = "",
  ...props
}: CustomIconButtonProps) => {
  let styleBasedSizeProp:Record<SizeType, string> = {
    lg: "h-9 w-9",
    sm: "h-6 w-6",
    filter: "h-4 w-4"
  };

  let styleBasedVariantProp:Record<VariantType, string> = {
    default: `text-[#808080] ${
      !disabled
        ? "hover:bg-[#FFF3E5] hover:text-[#FF861A] active:bg-[#FFF3E5] active:text-[#B35400] focus:bg-transparent focus:outline focus:outline-1 focus:outline-[#FF861A] focus:text-[#808080]"
        : ""
    } disabled:text-[#BBB] disabled:border-transparent`,
    icononly: `text-[#808080] ${
      !disabled
        ? "hover:text-[#FF861A] active:text-[#B35400] focus:text-[#808080]"
        : ""
    } disabled:text-[#BBB]`,
  };

  return (
    <>
      <button
        disabled={disabled}
        {...props}
        className={`${customStyle} rounded-full flex items-center justify-center ${styleBasedVariantProp[variant]} ${styleBasedSizeProp[size]}`}
      >
        {props.children}
      </button>
    </>
  );
};

export default CustomIconButton;
